<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** Field label for accessibility */
  label?: string | null
  /** Error message to display */
  error: string
}

const { label = null, error } = defineProps<Props>()

defineOptions({
  name: 'BaseError'
})

const accessibleError = computed(() => {
  if (label) {
    return `${label}: ${error}`
  }
  return error
})
</script>

<template>
  <p class="error-message block" role="alert" :aria-label="accessibleError">
    {{ error }}
  </p>
</template>
